"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var initialState = {
    notificationViewStates: [],
};
exports.default = satcheljs_1.createStore('headerToastNotificationViewState', initialState)();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/store/store.js
// module id = 366
// module chunks = 3 14 105 106 107